import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObject } from 'util/data';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const exports = storeModuleFactory({
    name:               'resourceTypes',
    endpoint:           endpoints.resourceTypes.endpoint,
    instanceEndpoint:   endpoints.resourceTypes.instanceEndpoint,
    timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    transformResultsFn: json => transformResultsFromObject(json.results)
});

const
    ID_RESOURCETYPE_VM = 1, //Virtual machine
    ID_RESOURCETYPE_DB = 2, //Database
    ID_RESOURCETYPE_COG = 3, //Cog
    ID_RESOURCETYPE_IC = 4; //Internet connection

exports.resourceTypesCodes = {
    ID_RESOURCETYPE_VM,
    ID_RESOURCETYPE_DB,
    ID_RESOURCETYPE_COG,
    ID_RESOURCETYPE_IC

};
exports.resourceTypesIcons = {
    [ID_RESOURCETYPE_VM]:  'cube',
    [ID_RESOURCETYPE_DB]:  'database',
    [ID_RESOURCETYPE_COG]: 'cog',
    [ID_RESOURCETYPE_IC]:  'wifi'

};

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/resourceTypes.js